import { render, staticRenderFns } from "./subtask-list.vue?vue&type=template&id=7dc33ca1&scoped=true&"
import script from "./subtask-list.vue?vue&type=script&lang=js&"
export * from "./subtask-list.vue?vue&type=script&lang=js&"
import style0 from "./subtask-list.vue?vue&type=style&index=0&id=7dc33ca1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc33ca1",
  null
  
)

export default component.exports